import React from "react";
import "antd/dist/antd.css";

import Layout from "./Layout/Layout";

const App = () => {
  return <Layout />;
};

export default App;
